import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import {
  Checkbox,
} from '../../../base';

import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';

const styles = theme => ({
  starIcon: {
    padding: 0,
    marginRight: theme.spacing(),

    [theme.breakpoints.up('md')]: {
      marginRight: 0,
    },
  },
});

const TagJob = ({
  classes: c,
  handleClick,
  isChecked,
  iconColor,
  value,
}) => {
  return (
    <Checkbox
      className={c.starIcon}
      icon={<StarBorder color={iconColor}/>}
      checkedIcon={<Star color={iconColor}/>}
      checked={isChecked}
      value={value}
      onChange={handleClick}
    />
  );
}

export default withStyles(styles)(TagJob)



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/TagJob/TagJob.js